import { Image } from '@ds';
import { OrganType } from '@/api/apis/case';
import { UserAvatarWithPrimary } from '../components';
import { getOrganImg } from '@/utils/helpers';

export const CLNameCell = ({
  name,
  photo,
  isPrimary = false,
  csOrganCertificates,
}: {
  name: string;
  photo: string;
  isPrimary?: boolean;
  csOrganCertificates: OrganType[] | null;
}) => {
  return (
    <div className="flex items-center gap-2">
      <UserAvatarWithPrimary name={name} photo={photo} isPrimary={isPrimary} />
      <div className="flex flex-col">
        <div className="text-m-m">{name}</div>
        <div className="flex flex-col text-s-r text-base-20">
          <span>Clinical Lead</span>
          {csOrganCertificates && csOrganCertificates.length > 0 && (
            <div className="flex items-center gap-1">
              <span>Clinical Specialist</span>
              {csOrganCertificates.map((organ) => (
                <Image key={organ} src={getOrganImg(organ)} alt={organ} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
